/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.sekap1794

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.sekap1794Routing(app: App): Navigo {
  return on("/sekap1794_nowy/:token", { params ->
    Model.nowy(stringProperty(params, "token"), app)
  }).on("/sekap1794_edycja/:token", { params ->
    Model.edycja(stringProperty(params, "token"), app)
  })
}
